import {
  ChatSettingAction,
  ChatSettingActionTypes,
  IChatSettingState,
  ChatIconSize,
  ChatLauncherStyleType
} from "./types";

const defaultState: IChatSettingState = {
  mainTitle: "",
  mainColor: "",
  subColor: "",
  title: "",
  endMessages: [""],
  openText: "",
  guideTitleA: "",
  guideTitleB: "",
  guideTitleC: "",
  guideMessageA: "",
  guideMessageC: "",
  titleImage: "",
  iconImage: "",
  chatImages: [],
  launcherImage: "",
  launcherStyleType: ChatLauncherStyleType.StyleA,
  loading: false,
  error: "",
  iconSize: ChatIconSize.LARGE,
  isSync: false
};
export default function chatSettingReducers(
  state = defaultState,
  action: ChatSettingActionTypes
) {
  switch (action.type) {
    case ChatSettingAction.INIT_CHATBOT_SETTING:
      return {
        ...state,
        mainTitle: action.payload.chatSettingData.mainTitle,
        endMessages: action.payload.chatSettingData.endMessages,
        mainColor: action.payload.chatSettingData.mainColor,
        subColor: action.payload.chatSettingData.subColor,
        title: action.payload.chatSettingData.title,
        openText: action.payload.chatSettingData.openText,
        guideTitleA: action.payload.chatSettingData.guideTitleA,
        guideTitleB: action.payload.chatSettingData.guideTitleB,
        guideTitleC: action.payload.chatSettingData.guideTitleC,
        guideMessageA: action.payload.chatSettingData.guideMessageA,
        guideMessageC: action.payload.chatSettingData.guideMessageC,
        titleImage: action.payload.chatSettingData.titleImage,
        iconImage: action.payload.chatSettingData.iconImage,
        chatImages: action.payload.chatSettingData.chatImages,
        launcherImage: action.payload.chatSettingData.launcherImage,
        launcherStyleType: action.payload.chatSettingData.launcherStyleType,
        iconSize: action.payload.chatSettingData.iconSize
      };
    case ChatSettingAction.CHANGE_MAIN_COLOR:
      return {
        ...state,
        mainColor: action.payload.mainColor
      };
    case ChatSettingAction.CHANGE_TITLE:
      return {
        ...state,
        title: action.payload.title
      };
    case ChatSettingAction.CHANGE_MAIN_TITLE:
      return {
        ...state,
        mainTitle: action.payload.title
      };
    case ChatSettingAction.CHANGE_END_MESSAGES:
      return {
        ...state,
        endMessages: action.payload.endMessages
      };
    case ChatSettingAction.CHANGE_OPEN_TEXT:
      return {
        ...state,
        openText: action.payload.openText
      };
    case ChatSettingAction.CHANGE_GUIDE_TITLEA:
      return {
        ...state,
        guideTitleA: action.payload.guideTitleA
      };
    case ChatSettingAction.CHANGE_GUIDE_TITLEB:
      return {
        ...state,
        guideTitleB: action.payload.guideTitleB
      };
    case ChatSettingAction.CHANGE_GUIDE_TITLEC:
      return {
        ...state,
        guideTitleC: action.payload.guideTitleC
      };
    case ChatSettingAction.CHANGE_GUIDE_MESSAGEA:
      return {
        ...state,
        guideMessageA: action.payload.guideMessageA
      };
    case ChatSettingAction.CHANGE_GUIDE_MESSAGEC:
      return {
        ...state,
        guideMessageC: action.payload.guideMessageC
      };
    case ChatSettingAction.CHANGE_SUB_COLOR:
      return {
        ...state,
        subColor: action.payload.subColor
      };
    case ChatSettingAction.CHANGE_TITLE_IMAGE:
      return {
        ...state
        // titleImageUrl: action.payload.imageUrl
      };
    case ChatSettingAction.CHANGE_CHAT_IMAGES:
      return {
        ...state,
        chatImages: action.payload.chatImages
      };
    case ChatSettingAction.POST_CHATSETTING_REQUEST:
      return {
        ...state,
        loading: true,
        isSync: false
      };
    case ChatSettingAction.POST_CHATSETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        isSync: true
      };
    case ChatSettingAction.POST_CHATSETTING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        isSync: false
      };
    case ChatSettingAction.CHANGE_CHAT_ICON_SIZE:
      return {
        ...state,
        iconSize: action.payload.size
      };
    case ChatSettingAction.CHANGE_CHAT_LAUNCHER_STYLE:
      return {
        ...state,
        launcherStyleType: action.payload.style
      };
    case ChatSettingAction.CHANGE_IS_SYNC:
      return {
        ...state,
        isSync: false
      };
    default:
      return state;
  }
}
